import { css } from '@emotion/react';
import { global } from '../../../../src/style/global.styles';

import { generateGlobalVars } from '../generators';
import { media } from './media';
import { setup } from './setup';
import { table } from './table';
import { textarea } from './textarea';

export const globalStyles = css`
  :root {
    ${generateGlobalVars()}
  }
  ${setup}
  ${media}
  ${table}
  ${textarea}
  ${global}
`;
